module.exports = __webpack_public_path__ + "img/2968995.jpg";